// extracted by mini-css-extract-plugin
module.exports = {"confirm_data":"ContractSavingsStartAllianz_confirm_data_2bNLF"};